/**
 * AlternativesList component.
 */
define([
    'jQuery',
    'underscore',
    'library/fcse-compatibility/object',
    'library/fcse-component/optionsMixin',
    'library/fcse-events/eventDispatcher',
    'library/fcse-dropdown/dropdown',
    'clientComponents/inlinemodal/inlineModal',
    'library/fcse-util/url',
    'library/fcse-util/paramConverter',
    'clientComponents/offervaliditycheck/offerValidityCheckButton'
    ],
    function($, _, Object, OptionsMixin, EventDispatcher, Dropdown, InlineModal, Url, ParamConverter, OfferValidityCheckButton) {

        var AlternativesList = function(element, requestHandler, options) {
            EventDispatcher.apply(this, arguments);

            // Set default options
            var defaultOptions = {};

            // Store element
            this.element = $(element);

            // Save local variables
            this.requestHandler = requestHandler;
            this.initialRouteParams = $(element).data("initial-route-params");

            this.addOptions(defaultOptions, options);
            this._init();
        };

        AlternativesList.prototype = $.extend(Object.create(EventDispatcher.prototype), Object.create(OptionsMixin),{
            /**
             * Initialize Offerlist
             *
             * @private
             */
            _init: function() {
                var self = this;
                // Create offer validity check buttons
                $('[data-fcse-role="check-offer-button"]', this.element).each(function(idx, elem){
                    new OfferValidityCheckButton(elem, self.requestHandler);
                });
            }
        });

        return AlternativesList;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/alternatives/alternativesList.js